import { Translation } from '@shared/types/translation';

export const TASK_FORM_MANAGEMENT_LABELS = {
  PREVIEW_NOTE_PREFIX: {
    english: 'Note:',
    polish: 'Uwaga:',
  },
  PREVIEW_NOTE: {
    english:
      'This is how the form will appear to Technician. You can interact with the fields to test the experience, but no data will be saved.',
    polish:
      'tak formularz będzie wyglądał dla technika. Możesz korzystać z pól, aby przetestować działanie, ale żadne dane nie zostaną zapisane.',
  },
  VIEW_TAB_TECHNICIANS: {
    english: 'Assigned Technicians',
    polish: 'Przypisani technicy',
  },
  VIEW_TECHNICIANS_EMPTY_TITLE: {
    english: 'No technicians assigned yet.',
    polish: 'Nie przypisano jeszcze żadnych techników.',
  },
  VIEW_TECHNICIANS_EMPTY_SUBTITLE: {
    english: 'Technicians will appear here once they are assigned.',
    polish: 'Technicy pojawią się w tym miejscu po przypisaniu.',
  },
  EDIT_TITLE: {
    english: 'Edit Task Form',
    polish: 'Edytuj formularz zadania',
  },
  SIGNATURE_INSTRUCTION: {
    english:
      "Use stylus or touch input to capture the client's digital signature directly on the device.",
    polish:
      'Użyj rysika lub dotyku ekranu, aby pobrać podpis cyfrowy klienta bezpośrednio na urządzeniu.',
  },
  LABEL_EQUIPMENT_ID_DISPLAY: {
    english: 'Equipment ID',
    polish: 'ID aparatury',
  },
} as const satisfies Record<string, Translation>;
